import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/reports/$countryCode/daily-payouts")({
  beforeLoad: () => ({
    breadcrumb: "Daily Payouts",
  }),
  component: Outlet,
});
